import { Link } from 'react-router-dom';

interface EmptyStateProps {
  title?: string;
  description?: string;
  primaryLabel?: string;
  primaryTo?: string;
  onReset?: () => void;
}

export default function EmptyState({
  title = '暂无相关内容',
  description = '换个条件试试，或者返回首页看看最新爆料。',
  primaryLabel = '返回首页',
  primaryTo = '/',
  onReset,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-300">
        <i className="ri-file-search-line text-3xl"></i>
      </span>
      <h3 className="mt-4 text-base font-bold text-foreground-900">{title}</h3>
      <p className="mt-2 max-w-sm text-sm text-foreground-500">{description}</p>
      <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
        {onReset && (
          <button
            type="button"
            onClick={onReset}
            className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            重置筛选条件
          </button>
        )}
        <Link
          to={primaryTo}
          className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          {primaryLabel}
        </Link>
      </div>
    </div>
  );
}